<template>
  <div class="w-100" style="height: 92%">
    <div style="position: relative;">
      <a-menu
        mode="horizontal"
        :selected-keys="defaultSelectedKeys"
        @click="clickMenuItem"
      >
        <a-menu-item key="/preview/detail" v-if="isPreviewShow">{{ $t('station.preview') }}</a-menu-item>
        <a-menu-item key="/preview/statistics">{{ $t('station.statistics') }}</a-menu-item>
        <a-menu-item v-if="authorities.find(a => a.code==='device:manage:device:group:stats:query')" key="/preview/dataStatistics">{{ $t('station.dataReport') }}</a-menu-item>
        <a-menu-item v-if="authorities.find(a => a.code==='device:manage:device:group:stats:query')" key="/preview/dataReport">{{ $t('station.dataReport1') }}</a-menu-item>
        <a-menu-item key="/preview/setWarning">{{ $t('station.warning') }}</a-menu-item>
      </a-menu>
      <a-button style="position: absolute; right: 30px; transform: translateY(calc(-100% - 8px))" @click="$router.replace('/equipment/group')">{{ $t('buttons.goBack') }}</a-button>
    </div>
    <div class="w-100 h-100">
      <router-view />
    </div>
  </div>
</template>

<script>
import { getDeviceGroup } from '@/api/device'

export default {
  name: 'index',
  data () {
    return {
      stationCode: '',
      defaultSelectedKeys: ['/preview/detail'],
      authorities: [],
      isPreviewShow: false
    }
  },
  created () {
    this.authorities = this.getAuthorities('/equipment/group')
    if (this.$route.path) {
      this.defaultSelectedKeys = [this.$route.path]
    }
  },
  mounted () {
    this.stationCode = this.$route.query.stationCode
    this.gotoDefaultRoute()
  },
  methods: {
    clickMenuItem ({ key }) {
      this.defaultSelectedKeys = [key]
      this.$router.push({ path: key, query: { id: this.$route.query.id, stationCode: this.stationCode, customerId: this.$route.query.customerId } })
    },
    async gotoDefaultRoute () {
      try {
        const { data } = await getDeviceGroup(this.$route.query.id)
        if (data.elecVisible) {
          this.isPreviewShow = false
          if (this.$route.path === "/preview") {
            this.$router.replace({ path: "/preview/dataStatistics", query: { id: this.$route.query.id, stationCode: this.stationCode, customerId: this.$route.query.customerId } })
            this.defaultSelectedKeys = ["/preview/dataStatistics"]
          }
        } else {
          this.isPreviewShow = true
          if (this.$route.path === "/preview") {
            this.$router.replace({ path: "/preview/detail", query: { id: this.$route.query.id, stationCode: this.stationCode, customerId: this.$route.query.customerId } })
            this.defaultSelectedKeys = ["/preview/detail"]
          }
        }
      } catch(e) {
        console.log(e)
      }
    }
  }
}
</script>

<style scoped>

</style>
